(function () {
  function disableOwlDrag() {
    if (!window.jQuery) return;
    var $ = window.jQuery;

    // Sadece ürün sayfası galerisi
    var $c = $('.product-single-carousel.owl-carousel');
    if (!$c.length) return;

    $c.each(function () {
      var $el = $(this);

      // Owl init olduysa ayarları kapat
      var api = $el.data('owl.carousel');
      if (api && api.settings) {
        api.settings.mouseDrag = false;
        api.settings.touchDrag = false;
        api.settings.pullDrag  = false;
        $el.trigger('refresh.owl.carousel');
      }

      // Drag eventlerini de sök (Fastor bazen tekrar bağlar)
      $el.removeClass('owl-drag');
      $el.off('mousedown.owl.drag touchstart.owl.drag');
      $el.off('mousemove.owl.drag touchmove.owl.drag');
      $el.off('mouseup.owl.drag touchend.owl.drag touchcancel.owl.drag');

      // Dikey scroll serbest
      $el.find('.owl-stage-outer').css('touch-action', 'pan-y');
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    disableOwlDrag();

    // Fastor bazı durumlarda sonradan re-init yapıyor, onu da yakala
    setTimeout(disableOwlDrag, 500);
    setTimeout(disableOwlDrag, 1500);
  });
})();
if (window.Slider && typeof window.Slider.zoomImage === 'function') {
  window.Slider.zoomImage = function(){};
}
document.addEventListener('DOMContentLoaded', function () {
  const selectors = [
    '.btn-quickview',
    '.btn-zoom',
    '.quickview',
    '.zoom',
    '.product-zoom',
    '.product-action',
    '.product-actions',
    '.product-buttons',
    '.product-tools',
    '.btn-product-icon',
    '.image-overlay',
    '.overlay'
  ];

  function nukeLupes() {
    document.querySelectorAll(selectors.join(',')).forEach(el => {
      el.remove();
    });
  }

  nukeLupes();

  // AJAX / filtre / infinite scroll sonrası tekrar gelirse
  const observer = new MutationObserver(() => nukeLupes());
  observer.observe(document.body, { childList: true, subtree: true });
});